import { atom, useRecoilState } from 'recoil';
import { Inbody } from '../types';

const $roundInfoState = atom<Inbody | null>({
  key: 'roundInfoState',
  default: null
});

export const useRoundInfoState = () => {
  const [roundInfo, setRoundInfo] = useRecoilState($roundInfoState);
  return {
    roundInfo,
    setRoundInfo
  };
};
